import * as React from "react";
import { groupAuth } from "app/utils/authGroups";
import UploadsContainer from "./Ops.CardTerminals.UploadContainer";

type State = {
  search: string;
};

export default class List extends React.Component<any, State> {
  state = {
    search: null,
  };

  componentDidMount() {
    this.props.setHeader({
      title: "Ops > Card Terminals",
      description: "SnapScan card terminals",
    });
  }

  render() {
    return (
      <React.Fragment>
        {groupAuth.hasAccessGroup(["Ops/Admin"]) ? <UploadsContainer /> : null}
      </React.Fragment>
    );
  }
}
